import React from 'react'
import {DropboxUpload} from '../../containers'

export default function DropboxUploadScreen() {
  return <DropboxUpload />
}
